import { Component, h, Prop } from '@stencil/core';

@Component({
  tag: 'envc-breadcrumb-item',
  styleUrl: 'envc-breadcrumb-item.scss',
  shadow: false,
  scoped: true
})
export class EnvcBreadcrumbItem {
  @Prop() url: string;
  @Prop() linkTitle: string;
  @Prop() dataLayerEntry: string;
  @Prop() isActive: boolean;
  @Prop() listIndex: number;

  private handleIndex(): string {
    return this.listIndex > 0 ? 'breadcrumb-item--arrow' : ''
  }

  private getClass(): string {
    return this.isActive ? `breadcrumb-item--active ${this.handleIndex()}` : this.handleIndex();
  }

  render() {
    return (
      <li data-tpl="breadcrumb-item" aria-selected="false" class={this.getClass()}>
        <a href={this.url} target="_self" data-layer-entry={this.dataLayerEntry}>
          {this.linkTitle}
        </a>
      </li>
    );
  }
}
